'use client';

import React from 'react';
import { RevshareSubscriber } from '../types';

interface IncomeCellProps {
  subscriber: RevshareSubscriber;
}

const IncomeCell: React.FC<IncomeCellProps> = ({ subscriber }) => {
  // Map new API structure - handle string or number
  const rawAmount = subscriber.transactions_total_amount;
  const amount = typeof rawAmount === 'string' ? parseFloat(rawAmount) || 0 : rawAmount || 0;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <span className="text-auth-ink text-sm font-semibold">${amount.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default IncomeCell;
